import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import 'lenis/dist/lenis.css';
import '@/App.css';
import '@/lore.css';
import '@/journal.css';
import '@/cosmology.css';
import '@/bestiary-base.css';
import '@/bestiary.css';
import '@/unbound.css';
import '@/journal-bestiary.css';
import '@/sigil.css';
import { Header } from './components/Header';
import { Hero, Marquee } from './components/Hero';
import { Books } from './components/Books';
import { WorldMap } from './components/WorldMap';
import { History, Illustrations } from './components/WorldStories';
import { Footer } from './components/Footer';
import { JournalPreview } from './components/journal/JournalPreview';
import { BestiaryPreview } from './components/bestiary/BestiaryPreview';
import { ReadingListProvider } from './components/journal/ReadingList';
import { usePageNavigation } from './hooks/usePageNavigation';
import { usePageMetadata } from './hooks/usePageMetadata';
import Journal from './pages/Journal';
import JournalArticle, { JournalNotFound } from './pages/JournalArticle';
import Bestiary from './pages/Bestiary';
import BestiaryEntry from './pages/BestiaryEntry';

const Home = () => {
  usePageMetadata('The Aetherios — A Collection of Four Stories', 'Discover The Aetherios, a four-book fantasy series beginning with The Cartographers of Grace and The Weight of Wings. Explore the original world map of Eilador.');
  return <main id="main-content" tabIndex={-1}><Hero /><Marquee /><Books /><WorldMap /><History /><Illustrations /><BestiaryPreview /><JournalPreview /></main>;
};

const Site = () => {
  usePageNavigation();
  return <><a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a><Header /><Routes><Route path="/" element={<Home />} /><Route path="/bestiary" element={<Bestiary />} /><Route path="/bestiary/:slug" element={<BestiaryEntry />} /><Route path="/journal" element={<Journal />} /><Route path="/journal/:slug" element={<JournalArticle />} /><Route path="*" element={<JournalNotFound />} /></Routes><Footer /></>;
};

export default function App() {
  return <MotionConfig reducedMotion="user"><BrowserRouter><ReadingListProvider><Site /></ReadingListProvider></BrowserRouter></MotionConfig>;
}